export const convertTimestampToDate = (timestamp: number) => {
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

export const getDaysRemaining = (endDateInMilliseconds: number): number => {
  const now = Date.now();
  const timeDiff = endDateInMilliseconds - now;
  const daysRemaining = timeDiff / (1000 * 60 * 60 * 24);
  return Math.ceil(daysRemaining);
};

export const secToMilliseconds = (sec: number): number => {
  return sec * 1000;
};

export const milliToSeconds = (sec: number): number => {
  return sec / 1000;
};

export const convertMillisecondsToDateParts = (
  milliseconds: number,
): {
  day: string;
  month: string;
  year: string;
} => {
  const date = new Date(milliseconds);
  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const year = date.getUTCFullYear().toString().slice(-2);

  return {
    day,
    month,
    year,
  };
};

export const convertToDays = (time: number, unit: "seconds" | "milliseconds" | "nanoseconds" = "seconds"): number => {
  let timeInSeconds: number;

  switch (unit) {
    case "milliseconds":
      timeInSeconds = time / 1000;
      break;
    case "nanoseconds":
      timeInSeconds = time / 1_000_000_000;
      break;
    case "seconds":
    default:
      timeInSeconds = time;
  }

  return Math.trunc(timeInSeconds / (60 * 60 * 24));
};

const formatDate = (number: number, isDay?: boolean) => {
  if (isDay) {
    return number.toString();
  }
  return number > 9 ? number.toString() : `0${number}`;
};

export interface ITimeLeft {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
}

export const ONE_SECOND = 1000;
export const TIMESTAMP = {
  ONE_DAY: 60 * 60 * 24,
  ONE_HOUR: 60 * 60,
  ONE_MINUTE: 60,
};

export const formatCountdown = (diffInMilliSeconds: number): ITimeLeft => {
  const diffInSeconds = Math.floor(diffInMilliSeconds / ONE_SECOND);
  if (diffInSeconds <= 1) {
    return {
      days: formatDate(0, true),
      hours: formatDate(0),
      minutes: formatDate(0),
      seconds: formatDate(0),
    };
  }
  const days = Math.floor(diffInSeconds / TIMESTAMP.ONE_DAY);
  const hours = Math.floor((diffInSeconds - days * TIMESTAMP.ONE_DAY) / TIMESTAMP.ONE_HOUR);
  const minutes = Math.floor(
    (diffInSeconds - days * TIMESTAMP.ONE_DAY - hours * TIMESTAMP.ONE_HOUR) / TIMESTAMP.ONE_MINUTE,
  );
  const seconds =
    diffInSeconds - days * TIMESTAMP.ONE_DAY - hours * TIMESTAMP.ONE_HOUR - minutes * TIMESTAMP.ONE_MINUTE;
  return {
    days: formatDate(days, true),
    hours: formatDate(hours),
    minutes: formatDate(minutes),
    seconds: formatDate(seconds),
  };
};
